// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Subscriptions_AdminListResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Subscriptions_AdminListResponse — full franchise subscription roster.
 * Used by GET /subscriptions/admin/list.
 */
import type { Subscriptions_AdminSubscriptionRow } from './Subscriptions_AdminSubscriptionRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Subscriptions_AdminListResponseDados {
rows: Subscriptions_AdminSubscriptionRow[]
}

export type Subscriptions_AdminListResponse = ApiResponse<Subscriptions_AdminListResponseDados>;

registerResponseContract('Subscriptions_AdminListResponse', {
  rows: {
    type: 'array',
    required: true,
    items: {
      subscription_id:          { type: 'number',  required: false },
      franquia_id:              { type: 'number',  required: true },
      franchise_name:           { type: 'string',  required: false },
      plan_name:                { type: 'string',  required: false },
      status:                   { type: 'string',  required: false },
      started_at:               { type: 'string',  required: false },
      current_period_end:       { type: 'string',  required: false },
      grace_until:              { type: 'string',  required: false },
      days_remaining:           { type: 'number',  required: false },
      is_live:                  { type: 'boolean', required: false },
      provider:                 { type: 'string',  required: false },
      provider_customer_id:     { type: 'string',  required: false },
      provider_subscription_id: { type: 'string',  required: false },
      currency:                 { type: 'string',  required: false },
      price_provider_code:      { type: 'string',  required: false },
      name:                     { type: 'string',  required: false },
      description:              { type: 'string',  required: false },
      plan_id:                  { type: 'number',  required: false },
      plan_price_id:            { type: 'number',  required: false },
      exempt:                   { type: 'boolean', required: false },
      setup_paid:               { type: 'boolean', required: false },
      paid_through:             { type: 'string',  required: false },
      current_period_start:     { type: 'string',  required: false },
      grace_period_end:         { type: 'string',  required: false },
      created_at:               { type: 'string',  required: false },
      updated_at:               { type: 'string',  required: false },
      setup_status:             { type: 'string',  required: false },
    },
  },
})
